import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";

const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Envoie un événement "pageview" à chaque changement d'URL (si consentement donné)
        trackPageView(location.pathname + location.search);
    }, [location]);

    return null;
};

export default Analytics;
